import React, { useState } from "react";
import styled from "styled-components";
import axios from "axios";
import { Header3 } from "../components/elements/Header";
import { FormInput, InputLabel, AreaInput } from "../components/elements/Input";
import { useAuth } from "../context/auth";
import Popup from "reactjs-popup";
import Buttons from "../components/elements/Button";
import EmailPrompt from "../components/prompts/EmailPrompt";

const Desc = styled.h1`
  width: 326px;
  height: 140px;
  font-family: Poppins;
  font-size: 11px;
  line-height: 20px;
  letter-spacing: 0.1px;
  text-align: left;
  color: #ffffff;
`;

const StyledPopup = styled(Popup)`
  &-overlay {
    -webkit-backdrop-filter: blur(20px);
    backdrop-filter: blur(20px);
    background-color: rgba(4, 3, 3, 0.7);
  }
  &-content {
    position: absolute;
    color: #fdfffc;
    top: auto !important;
    bottom: 0px !important;
    overflow: auto;
    height: 100%;
    right: auto;
    width: 100%;
    left: 0px !important;
    border-radius: 20px;
    outline: none;
    padding-bottom: 10px;
    background-color: #040303;
    padding: 5px;
  }
`;

export default function EditEmail(props) {
  const [email, setEmail] = useState("");
  const { user } = useAuth();
  return (
    <>
      <Header3 style={{ marginTop: "70px" }}>Change email address</Header3>
      <form>
        <div className="mt-5">
          <InputLabel>Email Address:</InputLabel>
        </div>
        <div className="d-flex px-3">
          <FormInput
            placeholder="Your new email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="px-3 mt-3">
          <Desc>
            Your current email is <b>{user.data.email}</b>. What would you like
            to update it to? Your email is not displayed in your public profile
            on Ombré.<div>&nbsp;</div> Once you change your email address, we
            will send you a verification email for confirmation on your new
            email address.
          </Desc>
        </div>
        <div style={{ marginTop: "20px", marginBottom: "30px" }}>
          <StyledPopup
            trigger={
              <Buttons
                type="submit"
                mode="Dark"
                autoWidth={true}
                types="Primary"
              >
                Confirm
              </Buttons>
            }
            closeOnEscape
            arrow="false"
          >
            <EmailPrompt email={email} />
          </StyledPopup>
        </div>
        <div style={{ marginTop: "20px", marginBottom: "30px" }}></div>
      </form>
    </>
  );
}
